module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAMAAADjcdz2AAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAuAn69YqCee3InFxYTjQuHxAD4KKQj3BpZExINycmDQHL6rUnAAAAdklEQVQY013O6RKCMAwE4PSgooggyn32/V+SpJRJYP/lm51tAaDsPiDTW28ycQ8eY0uG2lMcgwvwYMjpVppBpwiXZxJqbAK+qdygZLTylvJHMCjzqOPukzoNjv2mOEMSYotDVnXKK85UzvjblwsVChVwljbJAXbMaQt+dAIUVQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.png
// module id = JhOT
// module chunks = 1